import { put } from "@redux-saga/core/effects";
import axios from "axios";

import { FormsService, GetFormResponse, GetFormsResponse } from "../../../services/forms";
import {
    completeFieldsData,
    completeFormButtonsStyles,
    completeFormSetting,
    completeFormStyles,
    getCompletedPaymentData,
} from "../../../helpers/dataManipulations";
import {
    setCurrentForm,
    getFormsSuccess,
    getFormsFailure,
    getUserFontsRequest,
    setFormStyles,
    initFormButtons,
} from "./../actionCreators";
import { IErrorType } from "../../types/errors.d";
import { IForm } from "../types";
import { InitPages } from "../../pages/actionCreators";
import { initFields } from "../../fields/actionCreators";
import { initLayout } from "../../layout/actionCreators";
import { getDeclarablePaymentData } from "../../../helpers/paymentActions";
import { initFormSettings } from "../../settings/actionCreators";
import { getDeclarableFormButtonsData } from "../../../helpers/submitButton";
import { initPayableFields, initPaymentData } from "../../payment/actionCreators";

export function* getFormsSaga() {
    try {
        const {
            data: { data: forms },
        }: GetFormsResponse = yield FormsService.getForms();

        const lastForm = forms[forms.length - 1];

        if (!lastForm) {
            throw Error("No forms");
        }

        const {
            data: { data: form },
        }: GetFormResponse = yield FormsService.getForm(lastForm._id);

        yield put(
            setCurrentForm({
                _id: form._id,
                name: form.name,
                status: form.status,
                createdAt: form.createdAt,
                updatedAt: form.updatedAt,
                integrations: form.integrations,
            } as IForm),
        );

        yield put(initFormSettings(completeFormSetting(form.settings.native!)));
        yield put(setFormStyles(completeFormStyles(form.styles)));
        yield put(InitPages({ list: form.pages }));
        yield put(initFields({ list: completeFieldsData(form.fields) }));
        yield put(initPayableFields({ list: form.fields, paymentSettings: form.paymentSettings! }));
        yield put(initLayout(form.layout));
        yield put(initFormButtons(getDeclarableFormButtonsData(completeFormButtonsStyles(form.styles.buttons))));
        yield put(
            initPaymentData(
                getDeclarablePaymentData(getCompletedPaymentData(form.paymentSettings ? form.paymentSettings : {})),
            ),
        );
        yield put(getFormsSuccess({ ownerId: form.userId }));
        yield put(getUserFontsRequest({}));
    } catch (error) {
        if (axios.isAxiosError(error))
            yield put(getFormsFailure({ errorType: IErrorType.AXIOS, data: error.response?.data }));
        else yield put(getFormsFailure({ errorType: IErrorType.NATIVE, data: error }));
    }
}
